import store from '@/store'
export default [
  {
    path: '/invoices',
    name: 'invoice',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice/index.vue')
  },
  {
    path: '/invoices/create',
    name: 'invoice-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice/create.vue')
  },
  {
    path: '/invoices/:id',
    name: 'invoice-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/invoice/show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('invoice/find', to.params.id)
      next()
    }
  }
]
